export default __webpack_public_path__ + "static/media/caera-mockup-small.e2a4cddd.png";